import {APP_MATERIAL_BUTTON_TIMEOUT} from '../redux/actions/commonActions';

export default function buttonTimeout(callback) {
    let timeout = setTimeout(() => {
        callback();
        clearTimeout(timeout);
    }, APP_MATERIAL_BUTTON_TIMEOUT);
}